import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetTrustdockVerificationsRequest,
  DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest,
  DefaultApiGetTrustdockIdentityVerificationsRequest,
  DefaultApiPostTrustdockWebhooksSnailMailRequest,
  DefaultApiPostTrustdockWebhooksRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getTrustdockVerifications = async (
  instance: AxiosInstance,
  params: DefaultApiGetTrustdockVerificationsRequest
) => {
  return await userApiDefaultApiFactory(instance).getTrustdockVerifications(
    params
  )
}

export const getTrustdockSubmitIdentificationDocumentPublishUrl = async (
  instance: AxiosInstance,
  params: DefaultApiGetTrustdockSubmitIdentificationDocumentPublishUrlRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTrustdockSubmitIdentificationDocumentPublishUrl(params)
}

export const getTrustdockIdentityVerifications = async (
  instance: AxiosInstance,
  params: DefaultApiGetTrustdockIdentityVerificationsRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getTrustdockIdentityVerifications(params)
}

export const postTrustdockWebhooksSnailMail = async (
  instance: AxiosInstance,
  params: DefaultApiPostTrustdockWebhooksSnailMailRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postTrustdockWebhooksSnailMail(params)
}

export const postTrustdockWebhooks = async (
  instance: AxiosInstance,
  params: DefaultApiPostTrustdockWebhooksRequest
) => {
  return await userApiDefaultApiFactory(instance).postTrustdockWebhooks(params)
}

// Do Not Remove this line ===@import api client===
